var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
import { forwardRef } from "react";
const SvgPlayThin = (_ref, ref) => {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 16,
    height: 16,
    viewBox: "0 0 16 16",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: ref,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M3.11111 16C3.48148 16 3.7963 15.8488 4.16667 15.6314L14.963 9.26167C15.7315 8.79858 16 8.49616 16 7.99527C16 7.49439 15.7315 7.19197 14.963 6.73833L4.16667 0.359126C3.7963 0.14176 3.48148 0 3.11111 0C2.42593 0 2 0.529238 2 1.35145V14.6391C2 15.4613 2.42593 16 3.11111 16ZM3.5838 14.1949C3.52825 14.1949 3.49121 14.1571 3.49121 14.0815V1.90906C3.49121 1.83346 3.52825 1.79565 3.5838 1.79565C3.62084 1.79565 3.65788 1.81456 3.69491 1.84291L13.9449 7.89134C13.9912 7.91969 14.0282 7.94805 14.0282 7.9953C14.0282 8.0268 14.0118 8.0541 13.9871 8.07441L3.69491 14.1571C3.65788 14.176 3.62084 14.1949 3.5838 14.1949Z",
    fill: "#414141"
  })));
};
const ForwardRef = /*#__PURE__*/forwardRef(SvgPlayThin);
export { ForwardRef as ReactComponent };
export default __webpack_public_path__ + "static/media/PlayThin.245d0fe22902a653f2a2c4c9c6735275.svg";